/** The offer card as a JPEG file for the share sheet: some share targets (TikTok) stumble on a PNG. */
export const SHARE_IMAGE_NAME = 'rewards-offer';

export function shareImageFileName(type: string): string {
  const extension = type === 'image/jpeg' ? 'jpg' : type.split('/')[1] || 'png';
  return `${SHARE_IMAGE_NAME}.${extension}`;
}

export type JpegEncoder = (blob: Blob) => Promise<Blob | null>;

/** Draws the image on a canvas and re-encodes it as JPEG; null when the browser cannot. */
export const encodeJpegInBrowser: JpegEncoder = async (blob) => {
  if (typeof createImageBitmap !== 'function' || typeof document === 'undefined') return null;
  try {
    const bitmap = await createImageBitmap(blob);
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const context = canvas.getContext('2d');
    if (!context) return null;
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(bitmap, 0, 0);
    bitmap.close?.();
    return await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.92));
  } catch {
    return null;
  }
};

/** A File for navigator.share: JPEG when the encoder manages it, the original bytes otherwise. */
export async function buildShareImageFile(blob: Blob, encodeJpeg: JpegEncoder = encodeJpegInBrowser): Promise<File> {
  const jpeg = blob.type === 'image/jpeg' ? null : await encodeJpeg(blob);
  const bytes = jpeg && jpeg.size > 0 ? jpeg : blob;
  const type = jpeg && jpeg.size > 0 ? 'image/jpeg' : blob.type;
  return new File([bytes], shareImageFileName(type), { type });
}
